import { useCallback, useMemo } from "react";
import { Checkbox, Table, Text } from "@mantine/core";
import type { QcSlide } from "../../types/qcReview";

interface Props {
  slide: QcSlide;
  disabled: boolean;
  onChange: (slide: QcSlide) => void;
}
export function QcSlideTableRow({ slide, disabled, onChange }: Props) {
  const dateOrdered = useMemo(
    () =>
      slide.createdAt
        ? new Date(slide.createdAt).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        : "—",
    [slide.createdAt]
  );
  const handleChange = useCallback(() => onChange(slide), [onChange, slide]);
  return (
    <Table.Tr bg={slide.isCompleted ? "green.0" : undefined}>
      <Table.Td>{slide.specimen?.number || "—"}</Table.Td>
      <Table.Td>{slide.block?.number || "—"}</Table.Td>
      <Table.Td>{slide.number}</Table.Td>
      <Table.Td>
        <Text size="sm" fw={600}>
          {slide.stain?.code || "—"}
        </Text>
        <Text size="xs" c="dimmed">
          {slide.stain?.description}
        </Text>
      </Table.Td>
      <Table.Td>{slide.requestedBy?.fullName || "—"}</Table.Td>
      <Table.Td>{dateOrdered}</Table.Td>
      <Table.Td>{slide.status.replace(/_/g, " ")}</Table.Td>
      <Table.Td>
        <Checkbox
          checked={slide.isCompleted}
          onChange={handleChange}
          disabled={disabled}
          color="green"
          aria-label={`Done ${slide.specimen?.number || ""} ${slide.number} ${
            slide.stain?.code || ""
          }`}
        />
      </Table.Td>
      <Table.Td>{slide.requestReason || slide.remarks || "—"}</Table.Td>
    </Table.Tr>
  );
}
